import { api } from '@marketplace-web/core-api/core-api-client-util'

import { ReportReasonCatalogSystem } from '../constants/report-reason'
import { GetIsAlertsGeneratorBusyResp, BrandDto, GetBrandsResp } from '../types/admin-alerts'

export const generateAlertsFromSearchParams = ({
  searchParams,
  reportReason,
  brand,
}: {
  searchParams: Record<string, string | Array<string> | undefined>
  reportReason: ReportReasonCatalogSystem | undefined
  brand?: BrandDto | null
}) =>
  api.post('/admin/alert_generators/execute', {
    item_search_params: searchParams,
    report_reason_code: reportReason,
    brand,
  })

export const generateAlertsFromFirstPage = ({
  itemIds,
  reportReason,
  brand,
}: {
  itemIds: Array<number>
  reportReason: ReportReasonCatalogSystem | undefined
  brand?: BrandDto | null
}) =>
  api.post('/admin/alert_generators/batch_execute', {
    item_ids: itemIds,
    report_reason_code: reportReason,
    brand,
  })

export const checkIsAlertsGeneratorBusy = () =>
  api.get<GetIsAlertsGeneratorBusyResp>('/admin/alert_generators/is_busy')

export const checkIsAlertsGeneratorBatchBusy = () =>
  api.get<GetIsAlertsGeneratorBusyResp>('/admin/alert_generators/is_batch_busy')

export const getBrands = ({ keyword }: { keyword?: string | null }) =>
  api.get<GetBrandsResp>(
    '/ontologies/content_detection/brands',
    keyword ? { params: { keyword } } : undefined,
  )
